module.exports = __webpack_public_path__ + "img/sign_230280668_1.8365b2d9.png";